<template>
    <transition name="dropdown-content">

        <div v-if="active" class="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu" aria-orientation="vertical">
            <div class="py-1" role="none">
                <slot />
            </div>
        </div>

    </transition>
</template>
  
<script>
export default {
    name: "AppDropdownContent",
    inject: ["sharedState"],
    computed: {
        active() {
            return this.sharedState.active;
        }
    }
};
</script>
  
<style>
.dropdown-content-enter-active,
.dropdown-content-leave-active {
    transition: all 0.2s;
}

.dropdown-content-enter,
.dropdown-content-leave-to {
    opacity: 0;
    transform: translateY(-5px);
}
</style>
  